import { useEffect, useRef } from "react";

/* Hero node-network canvas — ported from the source HTML (echoes the logo). */
export const NetworkCanvas = () => {
  const ref = useRef(null);

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const x = c.getContext("2d");
    const reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    let W, H, DPR, nodes = [], coreNodes = [], t = 0, raf;
    const palette = ["#e11d3c", "#c0185c", "#f7941d", "#ff6a3d", "#e11d3c", "#f7941d"];

    function build() {
      nodes = [];
      const cx = W / 2, cy = H / 2, R = Math.min(W, H) * 0.36, N = 11;
      for (let i = 0; i < N; i++) {
        const a = (i / N) * Math.PI * 2, rr = R * (0.55 + 0.45 * ((i % 3) / 2));
        nodes.push({ a, rr, cx, cy, rad: 6 + (i % 3) * 2.4, col: palette[i % palette.length], ph: Math.random() * Math.PI * 2, x: cx, y: cy });
      }
      coreNodes = [];
      const M = 7, cr = R * 0.16;
      for (let i = 0; i < M; i++) { const a = (i / M) * Math.PI * 2; coreNodes.push({ x: cx + Math.cos(a) * cr, y: cy + Math.sin(a) * cr, r: 3.4 }); }
    }
    function size() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      const r = c.getBoundingClientRect(); W = r.width; H = r.height;
      c.width = W * DPR; c.height = H * DPR; x.setTransform(DPR, 0, 0, DPR, 0, 0);
      build();
    }
    function frame() {
      t += reduce ? 0 : 0.006;
      x.clearRect(0, 0, W, H);
      nodes.forEach((n) => {
        const ang = n.a + t * 0.5;
        n.x = n.cx + Math.cos(ang) * n.rr + Math.sin(t * 1.3 + n.ph) * 3;
        n.y = n.cy + Math.sin(ang) * n.rr + Math.cos(t * 1.1 + n.ph) * 3;
      });
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i], pulse = 0.18 + 0.16 * Math.sin(t * 2 + i);
        x.strokeStyle = "rgba(225,29,60," + pulse.toFixed(3) + ")"; x.lineWidth = 1.1;
        x.beginPath(); x.moveTo(n.x, n.y); x.lineTo(W / 2, H / 2); x.stroke();
        const m = nodes[(i + 2) % nodes.length];
        x.strokeStyle = "rgba(247,148,29," + (pulse * 0.7).toFixed(3) + ")";
        x.beginPath(); x.moveTo(n.x, n.y); x.lineTo(m.x, m.y); x.stroke();
      }
      x.strokeStyle = "rgba(59,154,225,.5)"; x.lineWidth = 1;
      for (let i = 0; i < coreNodes.length; i++) {
        const a = coreNodes[i], b = coreNodes[(i + 1) % coreNodes.length];
        x.beginPath(); x.moveTo(a.x, a.y); x.lineTo(b.x, b.y); x.stroke();
      }
      coreNodes.forEach((cn) => { x.beginPath(); x.arc(cn.x, cn.y, cn.r, 0, 7); x.fillStyle = "#3b9ae1"; x.fill(); });
      nodes.forEach((n) => {
        const r = n.rad + Math.sin(t * 2 + n.ph) * 0.8;
        const g = x.createRadialGradient(n.x, n.y, 0, n.x, n.y, r * 2.4);
        g.addColorStop(0, n.col); g.addColorStop(1, "rgba(0,0,0,0)");
        x.fillStyle = g; x.beginPath(); x.arc(n.x, n.y, r * 1.7, 0, 7); x.fill();
        x.fillStyle = n.col; x.beginPath(); x.arc(n.x, n.y, r, 0, 7); x.fill();
      });
      raf = requestAnimationFrame(frame);
    }
    size();
    window.addEventListener("resize", size);
    frame();
    return () => { window.removeEventListener("resize", size); cancelAnimationFrame(raf); };
  }, []);

  return (
    <div className="canvas-shell" data-testid="hero-canvas">
      <canvas ref={ref} />
      <div className="canvas-badge"><i className="pulse" />SYSTEMS&nbsp;ALIGNED</div>
      <div className="canvas-tag">connected compliance network</div>
    </div>
  );
};
